import { ZephrFeature } from "./zephrFeature";

export default ZephrFeature;
